import type { ContactOrderStep } from "../../../../../../../../api/kehrblatt/contact-orders"

const terminalStatuses = new Set(["WAITING", "COMPLETED", "DONE", "CANCELED", "INVALID", "BLOCKED"])

const stringValue = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value.trim() : null

const dueTimestamp = (step: ContactOrderStep): number | null => {
  const candidate = stringValue(step.next_action_at) || stringValue(step.due_at)

  if (!candidate) return null

  const timestamp = new Date(candidate).getTime()

  return Number.isFinite(timestamp) ? timestamp : null
}

export const isDueManualLetterStep = (
  step: ContactOrderStep | null | undefined,
  now: Date = new Date(),
): step is ContactOrderStep => {
  if (!step || step.channel !== "LETTER") return false

  if ((step.status || "").toUpperCase() !== "READY") return false

  if (terminalStatuses.has((step.status || "").toUpperCase())) return false

  if (step.execution_mode !== "manual_letter_delivery") return false

  const due = dueTimestamp(step)

  return due !== null && due <= now.getTime()
}
